import { Button } from "@material-tailwind/react";

export function BlockLevelButton() {
  return <Button fullWidth>block level button</Button>;
}
